import {
    CHAT_CHANNEL_LIST_PAGE_LOADED,
    CHAT_CHANNEL_LIST_PAGE_UNLOADED,
    CHANNEL_DETAIL_PAGE_LOADED,
    CHANNEL_DETAIL_PAGE_UNLOADED,
    CHANNEL_DETAIL_NEXT_PAGE_LOADED,
    CHANNEL_DETAIL_SEARCH_LOADED,
    UPDATE_FIELD_CHANNEL_DETAIL_SEARCHTERM,
    CHAT_CHANNEL_CREATE,
    CHAT_CHANNEL_CREATE_UNLOADED,
    CHAT_CHANNEL_UPDATE_LOADED,
    CHAT_CHANNEL_UPDATE,
    CHAT_CHANNEL_UPDATE_UNLOADED,
    CHAT_CHANNEL_DELETE,
    CHAT_POST_DETAIL_LOADED,
    CHAT_POST_DETAIL_UNLOADED,
    CHAT_POST_DELETE,
    CHAT_POST_TOGGLE_DISPLAY,
    CHAT_TOGGLE_DISPLAY
} from '../constants/actionTypes'
import { PAGESIZE } from '../constants/config'
export default (state = {}, action) => {
    switch (action.type) {
        case CHAT_CHANNEL_LIST_PAGE_LOADED:
            return {
                ...state,
                channels: action.payload.channels,
            }
        case CHAT_CHANNEL_LIST_PAGE_UNLOADED:
        case CHANNEL_DETAIL_PAGE_UNLOADED:
        case CHAT_CHANNEL_CREATE_UNLOADED:
        case CHAT_CHANNEL_UPDATE_UNLOADED:
        case CHAT_POST_DETAIL_UNLOADED:
            return {}
        case CHANNEL_DETAIL_PAGE_LOADED:
        case CHANNEL_DETAIL_NEXT_PAGE_LOADED:
        case CHANNEL_DETAIL_SEARCH_LOADED:
        case CHAT_CHANNEL_UPDATE_LOADED:
            return {
                ...state,
                channel: action.payload.channel,
                posts: action.payload.posts,
                totalCount: action.payload.totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
                searchTerm: action.searchTerm,
                date_from: action.date_from,
                date_to: action.date_to,
            }
        case UPDATE_FIELD_CHANNEL_DETAIL_SEARCHTERM:
            return {
                ...state,
                [action.key]: action.value,
            }
        case CHAT_CHANNEL_CREATE:
        case CHAT_CHANNEL_UPDATE:
        case CHAT_CHANNEL_DELETE:
        case CHAT_POST_DELETE:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.error : null,
            };
        case CHAT_POST_DETAIL_LOADED:
        case CHAT_POST_TOGGLE_DISPLAY:
            return {
                ...state,
                post: action.payload.post,
            }
        case CHAT_TOGGLE_DISPLAY:
            return {
                ...state,
                channel: action.payload.post,
            }
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/reducers/chat.js